import { Injectable } from '@angular/core';
import { AbstractService, Config } from '@increff/commons';
import { Observable } from 'rxjs';
import { COUNTRY } from '../../interfaces/country.interface';
import { Rest } from '../rest.service';

@Injectable({
    providedIn: 'root'
})
export class ConstantsService {

    constructor(
      private abstractService: AbstractService,
      private urls: Rest,
      private config: Config
    ) { }

    getLoginModes(): Observable<Array<string>> {
        return this.abstractService?.exec(this.urls.loginModesUrl, 'GET', undefined, { ...this.config?.startupData?.extraHttpOptions });
    }

    getDefaultRoles(): Observable<Array<string>> {
        return this.abstractService?.exec(this.urls.defaultRolesUrl, 'GET', undefined, { ...this.config?.startupData?.extraHttpOptions });
    }

    getListOfCountries(): Observable<COUNTRY[]> {
        return this.abstractService?.exec(this.urls.listOfCountriesUrl, 'GET', undefined, { ...this.config?.startupData?.extraHttpOptions });
    }

}
